import {blockQuote} from "./blockQuote.js";
import {isSelectionBlank} from "../state.js";
import {trimmedBlockRangeLeft} from "./trim.js";
import {changeSet, insertSelected} from "./changes.js";
import {canInsertTopLevelBlockSelectable} from "./topLevel.js";

export function insertBlockQuote(placeholder) {
  if (containsNewLine(placeholder)) {
    throw "Placeholder can't contain new lines";
  }
  return ({state, dispatch}) => {
    if (canInsertTopLevelBlockSelectable({state})) {
      dispatch({...insert(state, placeholder), userEvent: "input.insertBlockQuote"});
    }
  };
}

function containsNewLine(placeholder) {
  return placeholder.indexOf("\n") > -1 || placeholder.indexOf("\r") > -1;
}

function insert(state, placeholder) {
  if (isSelectionBlank(state)) {
    return insertSelected(state, '> ', placeholder, '\n');
  }
  return insertSelectedBlock(state);
}

function insertSelectedBlock(state) {
  return changeByRangeTrimmedBlockLeftCursor(state, selectedText => {
    const {text, length} = blockQuote(selectedText);
    return {insert: text, cursor: length};
  });
}

function changeByRangeTrimmedBlockLeftCursor(state, textCursorCallback) {
  return state.changeByRange(range => {
    const {from, to, text} = trimmedBlockRangeLeft(state, range);
    const {insert, cursor} = textCursorCallback(text);
    return changeSet({from, to, insert, cursor});
  });
}
